import {
  handleUnauthorize,
  handleAuthSuccess,
  handleAuthError
} from "./actions";
import { handleActions } from "redux-actions";

export const loginReducer = handleActions(
  {
    [handleAuthSuccess]: (state, action) => {
      return {
        isLoggedIn: true,
        token: action.payload,
        error: undefined
      };
    },
    [handleAuthError]: (state, action) => ({
      isLoggedIn: false,
      token: undefined,
      error: action.payload
    }),
    [handleUnauthorize]: () => ({
      isLoggedIn: false,
      token: undefined,
      error: undefined
    })
  },
  {
    isLoggedIn: false,
    token: undefined,
    error: undefined
  }
);
